module.exports = __webpack_public_path__ + "static/media/send.0c4913b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/send.svg
// module id = 846
// module chunks = 0